import React, { Component } from "react"
import { Link } from "react-router"
import classnames from "classnames"
import HomeLogoIcon from "svg-inline-react"
import { Icon, ToolTip } from "@driftt/tide-core-legacy"
import ACCESS from "utils/Access"
import { NAV_ITEMS, DEFAULT_ITEMS } from "./config"
import { DRIFT_VIDEO_URL } from 'constants/ResourcesConstants'

import { getDriftCutover } from 'app/modules/access/api'

import UpgradeStatus from "./UpgradeStatus"
import NewAgentStatus from "./NewAgentStatus"
import AppSwitcher from "./AppSwitcher"
import Help from "./Help"
import Shipyard from "./Shipyard"
import Onboarding from './Onboarding'
import { pathOr } from 'ramda'

import LOGO from "!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/drift-icon-2020.svg"
import botSVG from "!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/navigation/bot-icon.svg"
import sequencesSVG from "!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/navigation/sequences.svg"
import "./style.styl"

class MainNav extends Component {

  state = {
    isPendingCutover: true,
    hasDriftHelpCutover: false,
    hasVideoIconCutover: false,
  }

  async componentWillMount() {
    const hasDriftHelpCutoverGate = async () => {
      return await getDriftCutover({ orgId: this.props.orgId, cutoverName: 'DRIFT_HELP' })
    }
    const hasDriftVideoCutoverGate = async () => {
      return await getDriftCutover({ orgId: this.props.orgId, cutoverName: 'DRIFT_VIDEO_IN_NAV' })
    }

    try {
      const { DRIFT_HELP: hasHelpCutoverGate } = await hasDriftHelpCutoverGate()
      const { DRIFT_VIDEO_IN_NAV: hasVideoIconCutoverGate } = await hasDriftVideoCutoverGate()
      this.setState({ 
        hasDriftHelpCutover: hasHelpCutoverGate,  
        hasVideoIconCutover: hasVideoIconCutoverGate, 
        isPendingCutover: false 
      })
    }
    catch(err) {
      console.warn(err)
      this.setState({ isPendingCutover: false })
    }
  }

  hideNav() {
    return (
      this.props.location.pathname.includes("welcome/") ||
      this.props.location.pathname.includes("install/verify") ||
      this.props.location.pathname.includes("setup-slack") ||
      this.props.location.pathname == "/oauth" ||
      (this.props.location.pathname.includes("/install/") &&
        !this.props.location.pathname.includes("/settings/setup"))
    )
  }

  isNavItemActive(path, additionalPaths = []) {
    return [path, ...additionalPaths].reduce((acc, pathItem) => {
      return acc || pathItem !== "/" && this.props.location.pathname.startsWith(pathItem)
    }, false)
  }

  isHomePath() {
    return (
      this.props.location.pathname === "/" ||
      this.props.location.pathname.startsWith("/home") ||
      this.props.location.pathname.startsWith("/dashboard")
    )
  }

  renderVideoNavIcon() {
    const { videoSignUpDone } = this.props
    
    return (
      <a
        href={videoSignUpDone
          ? DRIFT_VIDEO_URL
          : `${DRIFT_VIDEO_URL}/accounts/existing-redirect?access_type=nav_icon`}
        target="_blank"
        key="VIDEO"
      >
        <ToolTip component={<span className="video-nav-tooltip">Drift Video <Icon name="expand" className="video-nav-tooltip-expand"/></span>} flow="right">
          <Icon
            name="library"
            className="menu-item-icon"
            height={18}
            width={18}
          />
        </ToolTip>
      </a>
    )
  }

  userHasRequiredScopesOrRoles(item) {
    return ((ACCESS.hasAnyScope(item.requiredScopes) && !ACCESS.hasAnyScope(item.rejectIfHasScopes)) || 
    ACCESS.hasAnyRole(item.requiredRoles))
  }

  getAvailableNavItems() {
    const filteredItems = _.pick(NAV_ITEMS, DEFAULT_ITEMS)

    // eslint-disable-next-line
    return Object.entries(filteredItems).filter(([key, item]) => (
      this.userHasRequiredScopesOrRoles(item) && 
      (item.requiredGates ? ACCESS.hasGates(item.requiredGates) : true) &&
      (item.rejectIfHasGates ? !ACCESS.hasGates(item.rejectIfHasGates) : true) &&
      (item.hasAllGates ? ACCESS.hasAllGates(...item.hasAllGates) : true))
    )
  }

  renderNavItems = () => {
    const navItems = this.getAvailableNavItems()

    return navItems.map(([key, item]) => {
      
      if (key === "MEETINGS") {
        item.path = "/meetings"
        item.external = true
      } else if (key === "HELP_CENTER" && !this.state.hasDriftHelpCutover) {
        return
      } else if (key === "VIDEO" && !ACCESS.isAdmin() && this.state.hasVideoIconCutover) {
        return this.renderVideoNavIcon()
      } else if (key === "VIDEO") {
        return
      } else if (["PLAYBOOKS", "PLAYBOOKS_BOTS", "PLAYBOOKS_SEQUENCES"].includes(key)) {
        if (ACCESS.isAdmin() || ACCESS.isPlaybooksUser()) {
          return (
            <a
              href={item.path}
              className={classnames({ active: this.isNavItemActive(item.path, item.additionalPaths) })}
              key={key}
            >
              <ToolTip component={item.label} flow="right">
                <HomeLogoIcon className="menu-item-icon" src={botSVG} />
              </ToolTip>
            </a>
          )
        }

        if (ACCESS.isChatUser()) {
          return (
            <a
              href={item.path}
              className={classnames({ active: this.isNavItemActive(item.path, item.additionalPaths) })}
              key={key}
            >
              <ToolTip component="Sequences" flow="right">
                <HomeLogoIcon className="menu-item-icon" src={sequencesSVG} />
              </ToolTip>
            </a>
          )
        }

        return null
      } else if (item.path === '/inboxes' && this.props.isDesktopUser) {
        item.path = '/conversations'
        item.target = "_blank"
        item.external = true
      }

      if (item.external) {
        return (
          <a
            href={item.path}
            className={classnames({ active: this.isNavItemActive(item.path, item.additionalPaths) })}
            key={key}
            target={item.target || "_self"}
          >
            <ToolTip component={item.label} flow="right">
              <Icon
                name={item.iconSRC}
                className="menu-item-icon"
                height={item.height}
                width={item.width}
              />
            </ToolTip>
          </a>
        )
      }

      return (
        <Link
          to={item.path}
          className={classnames({ active: this.isNavItemActive(item.path, item.additionalPaths) })}
          key={key}
        >
          <ToolTip component={item.label} flow="right">
            <Icon
              name={item.iconSRC}
              className="menu-item-icon"
              height={item.height}
              width={item.width}
            />
          </ToolTip>
        </Link>
      )
    })
  }

  isConversationsRouteActive = () => {
    return this.props.location.pathname.startsWith("/inboxes/")
  }

  render() {
    const { trafficControlConfig, orgId, orgProperties } = this.props
    const hasShipyard = pathOr(false, ['hasShipyard'], trafficControlConfig)
    if (this.hideNav()) {
      return null
    }

    if (this.state.isPendingCutover) {
      return (
        <div
          className={classnames("main-navigation", "new-main-nav", {
            darkMode: false,
            "main-navigation--qa": window.__ENV__ !== "PRODUCTION"
          })}
        />
      )
    }

    var HOME_PATH = "/"
    if(ACCESS.isCalendarUser()){
      HOME_PATH = "/meetings"
    }
    else if(ACCESS.isPlaybooksUser()){
      HOME_PATH = "/playbooks"
    }

    return (
      <div
        className={classnames("main-navigation", "new-main-nav", {
          darkMode: false,
          "main-navigation--qa": window.__ENV__ !== "PRODUCTION"
        })}
      >
        <Link
          to={HOME_PATH}
          className={classnames("main-navigation-home logo", {
            active: this.isHomePath()
          })}
        >
          <span is tooltip={"Home"} flow="right">
            <Icon
              name="lightning-bolt-filled"
              className="logo-hover-bolt large"
              height={16}
              width={12}
            />
            <Icon
              name="lightning-bolt-filled"
              className="logo-hover-bolt small1"
              height={15}
              width={11}
            />
            <Icon
              name="lightning-bolt-filled"
              className="logo-hover-bolt small2"
              height={16}
              width={12}
            />
            <HomeLogoIcon src={LOGO} className="tide-icon drift-logo" />
          </span>
        </Link>
        <nav>{this.renderNavItems()}</nav>

        <div className="status-section">
          {hasShipyard && <Shipyard />}
          {ACCESS.isAdmin() && <Onboarding orgId={orgId} orgProperties={orgProperties} />}
          {ACCESS.isAdmin() && !ACCESS.hasPaidGates() && <UpgradeStatus />}
          <AppSwitcher showVideoOption={ACCESS.isAdmin() || !this.state.hasVideoIconCutover} />
          <Help />
          <NewAgentStatus hasDriftHelpCutover={this.state.hasDriftHelpCutover} />
        </div>
      </div>
    )
  }
}

export default MainNav



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/index.js